import React from 'react';
import styled, { css } from 'styled-components';
import clsx from 'classnames';

type TPreloader = {
    className?: string;
    color?: string;
    isShown?: boolean;
};

const Preloader = styled<React.FC<TPreloader>>(({ className }) => (
    <div className={className}>
        <div className={clsx('lds-ring')}>
            <div> </div>
            <div> </div>
            <div> </div>
            <div> </div>
        </div>
    </div>
))<TPreloader>`
    position: absolute;
    width: 100%;
    height: 100%;
    transition: 1000ms all;
    min-height: 300px;
    z-index: 100;

    ${({ isShown }) =>
        isShown
            ? css`
                  background-color: rgba(0, 0, 0, 0.5);
              `
            : css`
                  background-color: transparent;
                  z-index: -1;
                  pointer-events: none;
              `}

    & .lds-ring {
        display: inline-block;
        position: relative;
        width: 16px;
        height: 16px;
    }
    & .lds-ring div {
        box-sizing: border-box;
        display: block;
        position: absolute;
        width: 16px;
        height: 16px;
        border: 2px solid ${({ theme }) => theme.branding.primary.main};
        border-radius: 50%;
        animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        border-color: ${({ theme }) => theme.branding.primary.main} transparent
            transparent transparent;
    }
    & .lds-ring div:nth-child(1) {
        animation-delay: -0.45s;
    }
    & .lds-ring div:nth-child(2) {
        animation-delay: -0.3s;
    }
    & .lds-ring div:nth-child(3) {
        animation-delay: -0.15s;
    }
    @keyframes lds-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    ${({ theme }) => theme.mixins.flexCenter};
`;

export default Preloader;
